import { BottomSheet } from "react-spring-bottom-sheet";
import { ReactNode } from "react";

type IBottomSheetCompProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

const BottomSheetComp = ({
  isOpen,
  onClose,
  children,
}: IBottomSheetCompProps) => {
  return (
    <BottomSheet
      style={
        {
          "--rsbs-backdrop-bg": "rgba(0, 0, 0, 0.8)",
          "--rsbs-bg": "black",
          "--rsbs-handle-bg": "rgba(225,225,225,0.3)",
        } as any
      }
      open={isOpen}
      onDismiss={onClose}
    >
      <style>
        {`
[data-rsbs-overlay] {
 box-shadow: 0 -5px 0px rgba(225, 225, 225, 0.2) !important;
}
`}
      </style>
      {children}
    </BottomSheet>
  );
};

export default BottomSheetComp;
